import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Logout = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const logout = async () => {
      try {
        const token = sessionStorage.getItem("token")
        const currentUsername = sessionStorage.getItem("current_username")

        // Clean up cross-tab communication first
        if (currentUsername) {
          const existingSessions = JSON.parse(localStorage.getItem("active_user_sessions") || "{}")
          delete existingSessions[currentUsername]
          localStorage.setItem("active_user_sessions", JSON.stringify(existingSessions))
        }

        // Call logout API
        if (token) {
          await fetch("https://api.rcube.tickbox.co.in/api/logout/", {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
        }

        // Clear this tab's session
        sessionStorage.clear()
        navigate("/")
      } catch (error) {
        console.error("Logout failed:", error)

        // Even if logout fails, clear session and redirect
        const currentUsername = sessionStorage.getItem("current_username")
        if (currentUsername) {
          const existingSessions = JSON.parse(localStorage.getItem("active_user_sessions") || "{}")
          delete existingSessions[currentUsername]
          localStorage.setItem("active_user_sessions", JSON.stringify(existingSessions))
        }

        sessionStorage.clear()
        navigate("/")
      }
    }

    logout()
  }, [navigate])

  return <p className="text-white text-center mt-10">Logging out...</p>
}

export default Logout
